import { Plus } from 'lucide-react';
import { useState } from 'react';

import { CreateModelForm } from './CreateModelForm';
import { ModelsFilter, ModelsFilterValue } from './ModelsFilter';
import { ModelsTable } from './ModelsTable';
import { RemoveModelDialog } from './RemoveModel';
import { UpdateModelForm } from './UpdateModelForm';

import { Button } from '@/components/ui/Button';
import { Card, CardContent } from '@/components/ui/Card';
import { FilterModelsDto, Model } from '@/services/ModelsService';

export function ModelsPage() {
  const [filter, setFilter] = useState<ModelsFilterValue>({});

  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openRemove, setOpenRemove] = useState(false);
  const [selectedModel, setSelectedModel] = useState<Model | null>(null);

  function handleEdit(model: Model) {
    setSelectedModel(model);
    setOpenEdit(true);
  }

  function handleRemove(model: Model) {
    setSelectedModel(model);
    setOpenRemove(true);
  }

  const filtersForQuery: FilterModelsDto = {
    promptName: filter.promptName,
    serviceName: filter.serviceName,
  };

  return (
    <Card className="min-h-screen rounded-lg shadow">
      <CardContent>
        <div className="mt-2 border-b bg-white">
          <div className="container mx-auto px-4 py-6">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Models</h1>
                <p className="mt-1 text-gray-600">Manage registered models</p>
              </div>
              <Button className="gap-2" onClick={() => setOpenCreate(true)}>
                <Plus className="h-4 w-4" />
                Add New Model
              </Button>
            </div>
          </div>
        </div>
        <div className="rounded-lg bg-gray-50">
          <div className="container mx-auto space-y-6 px-4 py-6">
            <Card>
              <CardContent className="p-4">
                <ModelsFilter onFilterChange={setFilter} filter={filter} />
              </CardContent>
            </Card>
            <ModelsTable
              filter={filtersForQuery}
              onEdit={handleEdit}
              onRemove={handleRemove}
            />
          </div>
        </div>

        <CreateModelForm
          open={openCreate}
          onClose={() => setOpenCreate(false)}
          onSuccess={() => {}}
          filter={filtersForQuery}
        />
        <UpdateModelForm
          open={openEdit}
          onClose={() => setOpenEdit(false)}
          model={selectedModel}
          onSuccess={() => {}}
          filter={filtersForQuery}
        />
        {selectedModel && (
          <RemoveModelDialog
            open={openRemove}
            onClose={() => setOpenRemove(false)}
            model={selectedModel}
            filter={filtersForQuery}
          />
        )}
      </CardContent>
    </Card>
  );
}

export default ModelsPage;
